import api from 'services/api/microfwk';

export function fetchUserBookmars(params) {
  return api.get('services/user/getbookmark', { params });
}
